function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebdev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAD24D"
    },
    cx: 255.999,
    cy: 255.999,
    r: 255.999
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M49.359,118.027h370.52c12.173,0,22.133,9.959,22.133,22.133v228.246H27.227V140.16 C27.227,127.987,37.186,118.027,49.359,118.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.256,353.376h384.729V140.16c0-3.876-3.227-7.103-7.103-7.103H49.362 c-3.876,0-7.103,3.227-7.103,7.103v213.216h-0.003V353.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M50.218,163.474h368.805v85.374H50.218V163.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B8"
    },
    d: "M7.082,368.406h455.076v12.782c0,7.029-5.753,12.782-12.782,12.782H19.861 c-7.029,0-12.782-5.753-12.782-12.782v-12.782H7.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191"
    },
    d: "M189.199,373.077h90.84l-9.731,6.463h-71.38l-9.731-6.463H189.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M331.128,198.396h136.094c4.316,0,7.814,3.498,7.814,7.814v179.945c0,4.316-3.498,7.814-7.814,7.814 H331.128c-4.316,0-7.814-3.498-7.814-7.814V206.21C323.314,201.894,326.813,198.396,331.128,198.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.814,212.237h132.724c0.501,0,0.907,0.406,0.907,0.907v161.608c0,0.501-0.406,0.907-0.907,0.907 H332.814c-0.501,0-0.907-0.406-0.907-0.907V213.145C331.907,212.644,332.313,212.237,332.814,212.237z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 399.178,
    cy: 384.487,
    r: 5.096
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M338.989,232.48h120.377v70.95H338.989V232.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M437.9,268.396h63.051c2.191,0,3.966,1.776,3.966,3.966v117.642c0,2.191-1.776,3.966-3.966,3.966 H437.9c-2.191,0-3.966-1.776-3.966-3.966V272.362C433.934,270.172,435.709,268.396,437.9,268.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M440.853,280.15h57.145c0.216,0,0.391,0.175,0.391,0.391v101.282c0,0.216-0.175,0.391-0.391,0.391 h-57.145c-0.216,0-0.391-0.175-0.391-0.391V280.54C440.462,280.325,440.638,280.15,440.853,280.15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 469.43,
    cy: 387.561,
    r: 3.586
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B8"
    },
    d: "M459.833,274.868h19.184c0.484,0,0.876,0.392,0.876,0.876v0.003c0,0.484-0.392,0.876-0.876,0.876 h-19.184c-0.484,0-0.876-0.392-0.876-0.876v-0.003C458.957,275.26,459.349,274.868,459.833,274.868z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M426.986,156.83H42.256V140.16c0-3.876,3.227-7.103,7.103-7.103h370.52 c3.876,0,7.103,3.227,7.103,7.103v16.669H426.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.441,139.861H403.52c1.453,0,2.636,1.186,2.636,2.636v4.891c0,1.453-1.186,2.636-2.636,2.636 H206.441c-1.453,0-2.636-1.186-2.636-2.636v-4.891C203.805,141.047,204.99,139.861,206.441,139.861z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M58.624,139.68c3.292,0,5.962,2.668,5.962,5.962s-2.67,5.962-5.962,5.962 c-3.295,0-5.967-2.668-5.967-5.962S55.327,139.68,58.624,139.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M82.16,139.68c3.295,0,5.962,2.668,5.962,5.962s-2.668,5.962-5.962,5.962 c-3.292,0-5.962-2.668-5.962-5.962S78.868,139.68,82.16,139.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M105.702,139.68c3.292,0,5.962,2.668,5.962,5.962s-2.67,5.962-5.962,5.962 c-3.298,0-5.967-2.668-5.967-5.962S102.404,139.68,105.702,139.68z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M91.149,269.445c9.503,0,17.204,7.701,17.204,17.204c0,9.5-7.701,17.204-17.204,17.204 c-9.5,0-17.201-7.704-17.201-17.204C73.948,277.146,81.649,269.445,91.149,269.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M180.029,269.445c9.5,0,17.201,7.701,17.201,17.204c0,9.5-7.701,17.204-17.201,17.204 s-17.201-7.704-17.201-17.204C162.828,277.146,170.529,269.445,180.029,269.445z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M66.467,311.229h49.37v2.678h-49.37V311.229z M66.467,328.059h33.16v2.678h-33.16V328.059z  M66.467,319.645h49.37v2.676h-49.37V319.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M155.348,311.229h49.367v2.678h-49.367V311.229z M155.348,328.059h33.163v2.678h-33.163V328.059z  M155.348,319.645h49.367v2.676h-49.367V319.645z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M274.374,269.445c9.5,0,17.201,7.701,17.201,17.204c0,9.5-7.701,17.204-17.201,17.204 c-9.5,0-17.201-7.704-17.201-17.204C257.172,277.146,264.873,269.445,274.374,269.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M249.692,311.229h49.367v2.678h-49.367L249.692,311.229L249.692,311.229z M249.692,328.059h33.163 v2.678h-33.163V328.059z M249.692,319.645h49.367v2.676h-49.367L249.692,319.645L249.692,319.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M362.963,313.651c5.896,0,10.678,4.782,10.678,10.678c0,5.896-4.779,10.678-10.678,10.678 c-5.896,0-10.678-4.782-10.678-10.678C352.285,318.432,357.065,313.651,362.963,313.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M347.642,339.587h30.642v2.167h-30.642V339.587z M347.642,353.203h20.583v2.167h-20.583V353.203z  M347.642,346.393h30.642v2.167h-30.642V346.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M404.64,313.651c5.896,0,10.678,4.782,10.678,10.678c0,5.896-4.782,10.678-10.678,10.678 c-5.896,0-10.678-4.782-10.678-10.678C393.962,318.432,398.744,313.651,404.64,313.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M389.319,339.587h30.642v2.167h-30.642V339.587z M389.319,353.203h20.583v2.167h-20.583V353.203z  M389.319,346.393h30.642v2.167h-30.642V346.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M466.446,227.782H331.904v-14.636c0-0.501,0.406-0.907,0.907-0.907h132.724 c0.501,0,0.907,0.406,0.907,0.907v14.636H466.446z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M341.877,216.66c1.936,0,3.502,1.566,3.502,3.499s-1.566,3.499-3.502,3.499 c-1.933,0-3.499-1.566-3.499-3.499S339.946,216.66,341.877,216.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M351.729,216.66c1.933,0,3.499,1.566,3.499,3.499s-1.566,3.499-3.499,3.499 s-3.499-1.566-3.499-3.499S349.796,216.66,351.729,216.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M361.581,216.66c1.933,0,3.499,1.566,3.499,3.499s-1.566,3.499-3.499,3.499 c-1.933,0-3.499-1.566-3.499-3.499S359.65,216.66,361.581,216.66z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.219,217.442h80.009c0.59,0,1.07,0.635,1.07,1.411v2.618c0,0.776-0.48,1.411-1.07,1.411h-80.009 c-0.59,0-1.07-0.635-1.07-1.411v-2.618C380.149,218.077,380.629,217.442,381.219,217.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M498.389,286.941h-57.927v-6.4c0-0.218,0.176-0.391,0.391-0.391h57.145 c0.216,0,0.391,0.173,0.391,0.391L498.389,286.941L498.389,286.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M444.554,281.299c1.107,0,2.001,0.894,2.001,2.001c0,1.104-0.894,2.001-2.001,2.001 c-1.104,0-2.001-0.897-2.001-2.001C442.553,282.193,443.45,281.299,444.554,281.299z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M450.186,281.299c1.107,0,2.001,0.894,2.001,2.001c0,1.104-0.894,2.001-2.001,2.001 s-2.001-0.897-2.001-2.001C448.185,282.193,449.081,281.299,450.186,281.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M455.817,281.299c1.107,0,2.001,0.894,2.001,2.001c0,1.104-0.894,2.001-2.001,2.001 c-1.104,0-2.001-0.897-2.001-2.001C453.816,282.193,454.713,281.299,455.817,281.299z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M463.951,281.558h32.208c0.432,0,0.781,0.35,0.781,0.781v2.093c0,0.432-0.35,0.781-0.781,0.781 h-32.208c-0.432,0-0.781-0.35-0.781-0.781v-2.093C463.17,281.909,463.52,281.558,463.951,281.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M443.272,289.134h52.308v30.831h-52.308V289.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M470.962,326.286c5.362,0,9.708,4.346,9.708,9.71c0,5.362-4.346,9.71-9.708,9.71 c-5.362,0-9.708-4.346-9.708-9.71C461.255,330.634,465.601,326.286,470.962,326.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M454.112,352.776h33.7v2.381h-33.7V352.776z M454.112,367.753h22.64v2.381h-22.64V367.753z  M454.112,360.264h33.7v2.381h-33.7V360.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB937"
    },
    d: "M40.323,393.97h431.353c-1.429,2.23-2.903,4.425-4.398,6.607H44.724 C43.229,398.395,41.753,396.199,40.323,393.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B8"
    },
    d: "M382.161,203.956h34.033c0.484,0,0.876,0.392,0.876,0.876v0.003c0,0.484-0.392,0.876-0.876,0.876 h-34.033c-0.484,0-0.876-0.392-0.876-0.876v-0.003C381.285,204.349,381.677,203.956,382.161,203.956z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdev);
export default __webpack_public_path__ + "static/media/webdev.360614d2e81601197bfde08f6f420d7a.svg";
export { ForwardRef as ReactComponent };